import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const LeadLink = (props) => {
  return (
    <Link to={`/crm/leads/${props.data.id}`}>{props.value}</Link>
  );
};

LeadLink.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  }).isRequired,
  value: PropTypes.node
};

export default LeadLink;
